/**
 * aggregate-viewing-time-by-bvod-service
 *
 * @author    Augusto Silvino <augusto.silvino@mediatel.co.uk>
 * @copyright 2017 Mediatel Limited.
 */

"use strict";

import tablesort from "tablesort";
import "../common/tablesort_numeric";

import renderWeeklyReport from "./render-aggregate-viewing-time-by-bvod-player";
import renderWeeklyReportCSV from "./render-aggregate-viewing-time-by-bvod-player-csv";
import fileDownloader from "../common/file-downloader";
import onXHRClickButton from "./onxhr-click-button";

export default (dataUrl, options={}) => sb => {
    let form,
        selectedPeriod = null,
        selectedDatatype = 0,
        currentData,
        toggleTotal = 1,
        filter,
        chartNote,
        report;

    const renderReport = (data, filter) => {
        hidePleaseWait();
        sb.empty(report).append(
            report,
            renderWeeklyReport(data, selectedDatatype, filter)
        );

        report.css("display", "table");

        const table = report.query("table");
        tablesort(table[0]);

        sb.notify({type: "tableUpdated"});
        sb.notify({type: "toggleTotal", data: sb.find('#show_total')[0].checked});
    };

    const downloadCSV = data => {
        fileDownloader(
            renderWeeklyReportCSV(data, {
                showTotal: toggleTotal,
                filter: filter,
                dataType: selectedDatatype
            }),
            'Aggregate-Viewing-Time-by-BVOD-Service.csv'
        );
    };

    const emptyDatagridContainer = () => {
        sb.empty(sb.find("div#datagrid_aggregate-viewing-time-by-tv-player"));
    };

    const showPleaseWait = () => {
        sb.show(sb.find("div.scroll_datagrid .wait"));
    };

    const hidePleaseWait = () => {
        sb.hide(sb.find("div.scroll_datagrid .wait"));
    };

    const onFormSubmit = e => {
        e.preventDefault();

        const postdata = {
            method: "POST",
            period: selectedPeriod,
            datatype: selectedDatatype
        };

        chartNote.css("display", "none");

        if ('undefined' !== typeof options.showSkyPcNote) {
            chartNote.css("display", "block");
        }

        sb.find('#show_total_block').removeClass('hidden');

        emptyDatagridContainer();
        showPleaseWait();

        sb.postApi(dataUrl, postdata).then(
            data => {
                currentData = data;
                const f = sb.find("#filter");
                if(f.length) {
                    filter = f[0].value;
                }
                return renderReport(currentData, filter);
            }
        ).then(() => {
            sb.notify({
                type: "toggleTotal",
                data: sb.find('#show_total')[0].checked
            });
        });
    };

    const onToggleTotal = e => {
        sb.notify({
            type: "toggleTotal",
            data: e.target.checked
        });
    };

    const onClickDownloadCSV = () => {
        const postdata = {
            method: "POST",
            period: selectedPeriod,
            datatype: selectedDatatype
        };
        showPleaseWait();
        sb.postApi(dataUrl,postdata)
            .then(downloadCSV)
            .then(hidePleaseWait);
    };

    return {
        init() {
            form = sb.find("form");
            chartNote = sb.find("#chartNote");
            const submit = form.query("#button_submit");

            sb.addEvent(form, "submit", onFormSubmit);
            sb.addEvent(sb.find("#button_download_trigger"), "click", onClickDownloadCSV);
            sb.addEvent(sb.find('#show_total_block'), "change", onToggleTotal);

            sb.listen({
                periodsSelectionChanged: period => selectedPeriod = period,
                datatypeSelectionChanged: datatype => selectedDatatype = datatype[0],
                toggleTotal : checked => {
                    toggleTotal = checked | 0;
                    if(checked) {
                        sb.find('tr.summary').removeClass('hidden');
                    } else {
                        sb.find('tr.summary').addClass('hidden');
                    }
                },
                tableFilter: filterText => {
                    filter = filterText;
                    if (currentData) {
                        renderReport(currentData, filter);
                    }
                }
            });

            report = sb.find("div#datagrid_aggregate-viewing-time-by-tv-player");

            // start default report
            onXHRClickButton(submit[0]);
        },
        destroy() {
            sb.ignore(["periodsSelectionChanged", "datatypeSelectionChanged", "tableFilter"]);

            sb.removeEvent(form, "submit", onFormSubmit);
            sb.removeEvent(sb.find("#button_download_trigger"), "click", onClickDownloadCSV);

            form = null;
        }
    }
};